/** The chat reads like a native assistant, not the storefront's typography. */
export const BRAND_CHAT_FONT = `-apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`
